<template>
  <div class="input">
    <div class="input-label">開催地</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="place">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    place: {
      get: function () {
        return this.$store.state.event.place
      },
      set: function (value) {
        this.$store.commit(
          'event/setPlace',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
